const equivalenceAuthObject = (auth: ReceivedAuthObjectT): AuthDataT => {
  const user = auth.user;
  return {
    id: auth.id,
    username: auth.username,
    token: auth.token,
    mobile: auth.mobile,
    created_at: auth.created_at,
    updated_at: auth.updated_at,
    user: {
      code: user?.code,
      address: user?.Address,
      avatar: user?.avatar,
      city: user?.city,
      province: user?.province,
      name: user?.name,
      phone: user?.phone,
      shopName: user?.store_name,
    },
  };
};

export default equivalenceAuthObject;
